import SceButton from '../../Common/CommonComponents/sceButton';
import classes from './CpcPopup.scss';
import { getLocalizedStrings } from '../centralizedLocalizedString';
const CpcPopup = (props) => {
 const strings = getLocalizedStrings('PaperlessBilling');
  return (
    <div className={classes.dialogContent} tabIndex='-1' role={strings.dialogRole} aria-describedby={strings.ariaDescribe} >
      <div className={classes.dialogContentArea}>
        <div className={classes.contentRow}>
          <p id='popupMessage_desc'><b>{props.msg}</b></p>
        </div>
        <div className={classes.contentRow}>
          <div className={[classes.buttonContainer, 'row', 'text-center'].join(' ')}>
              <SceButton buttonType={strings.defaultButton} value={strings.okButton} onClick={props.onDialogCloseHandler} />
          </div>
        </div>
      </div>
    </div>
  );
};
export default CpcPopup;
